<template>
  <!-- eslint-disable max-len -->
  <div id="app">
    <div id="page-container">
      <header>
        <nav>
          <div>
            <a href="/">
              <img alt="Driven"
                src="../../assets/driven_logo.png"/>
            </a>
          </div>
          <div class="navbar" v-if="! $globalObservableData.showNavDropown" style="padding-right: 30px;">
            <!-- <router-link to="/demo/">Home</router-link> -->
            <router-link to="/demo/ev_comparison">Compare EVs</router-link>
            <router-link to="/demo/savings_calculator">Calculate Savings</router-link>
            <router-link to="/demo/charger_comparison">Home Chargers</router-link>
            <router-link to="/demo/charger_map">Public Chargers</router-link>
            <router-link to="/demo/incentives">Available Incentives</router-link>
            <router-link to="/demo/dealers">Local Dealerships</router-link>
            <router-link to="/demo/events">Upcoming Events</router-link>
          </div>
          <div v-else>
            <b-dropdown right no-caret class="mobileNavDropdown">
              <template #button-content>
                <font-awesome-icon  icon="fa-solid fa-bars"/>
              </template>
              <!-- <b-dropdown-item> <router-link to="/demo/">Home</router-link> </b-dropdown-item> -->
              <b-dropdown-item href="/demo/ev_comparison"> <router-link to="/demo/ev_comparison">Compare EVs</router-link> </b-dropdown-item>
              <b-dropdown-item href="/demo/savings_calculator"> <router-link to="/demo/savings_calculator">Calculate Savings</router-link> </b-dropdown-item>
              <b-dropdown-item href="/demo/charger_comparison"> <router-link to="/demo/charger_comparison">Home Chargers</router-link> </b-dropdown-item>
              <b-dropdown-item href="/demo/charger_map"> <router-link to="/demo/charger_map">Public Chargers</router-link> </b-dropdown-item>
              <b-dropdown-item href="/demo/incentives"> <router-link to="/marincounty/incentives">Available Incentives</router-link> </b-dropdown-item>
              <b-dropdown-item href="/demo/dealers"> <router-link to="/demo/dealers">Local Dealerships</router-link> </b-dropdown-item>
              <b-dropdown-item href="/demo/events"> <router-link to="/demo/events">Upcoming Events</router-link> </b-dropdown-item>
            </b-dropdown>
          </div>
        </nav>
      </header>
      <main>
        <router-view/>
      </main>
      <footer id="footer" style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap; padding: 30px; column-gap: 40px;">
        <a href="https://www.thedrivenexperience.com" target="_blank" style="flex: 0 1 auto;">
          <img alt="Driven"
            src="../../assets/TagLine_Driven_Clr.png"
            style="width: 100%; max-width: 300px; filter: brightness(0) invert(1); vertical-align: top;" />
        </a>
        <div style="flex: 0 1 auto; margin-top: 10px; text-align: center; line-height: 140%;">
          EV Tools Powered by Driven. Find out more at
          <a href="https://thedrivenexperience.com" target="_blank" style="line-height: 140%;">The Driven Experience</a>.
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dollars_per_kwh: 0.20,
      client_api_path: 'demo',
      client_base_url: `${this.$base_url}/demo`,
      event_page_description: 'Welcome to the DrivenToElectrify electric vehicle events page! Here, you\'ll find all the latest information on upcoming electric vehicle events. Our aim is to help EV enthusiasts stay informed about upcoming events, including everything from ride-and-drives and car shows, to seminars and workshops, and more. By providing a centralized resource for electric vehicle events, we hope to promote the benefits of electric transportation and help accelerate the transition to sustainable energy. Whether you\'re a seasoned EV driver or simply interested in learning more, our website is the place to be for all the latest EV event news.',

      // FROM PACIFIC POWER:

      // Income Limits
      // AMI -- https://www.marinhousing.org/marin-county-income-limits
      household_size_ami: [
        122500, 140000, 157500, 175000, 186000, 203000, 217000, 231000, 245000,
      ],
      // SMI -- https://www.cde.ca.gov/sp/cd/ci/mb2205.asp unrelated program but only place I found SMI by household size chart
      household_size_smi: [
        84818, 84818, 96590, 112105, 130042, 147988, 151342, 154705, 158068, 161431, 164794, 168158,
      ],
      // FPL -- https://aspe.hhs.gov/topics/poverty-economic-mobility/poverty-guidelines
      household_size_fpl: [
        14580, 19720, 24860, 30000, 35140, 40280, 45420, 50560,
      ],
      // https://www.energysage.com/local-data/electricity-cost/ca/marin-county/#:~:text=Electric%20rates%20in%20Marin%20County%2C%20CA,-The%20easiest%20way&text=The%20average%20residential%20electricity%20rate,rate%20of%2018%20%C2%A2%2FkWh.
      // TODO this should prepopulate from whatever powerSource is selected....
      state: {
        dollarsPerKwh: 0.172,
        dollarsPerGallon: 4.65,
        emissionsPerKwh: 4.33 * (10 ** -4),
      },
      // client_api_path: 'pacificpower',
      ev_charger_description: '',
      ev_data: [],
      // ev_comparison_description: '* As you’re browsing through, consider <a href="https://www.mcecleanenergy.org/ev-rebate/"  target="_blank">MCE’s EV rebate</a> of up to $3,500 at participating dealerships.',
      // https://www.pacificpower.net/content/dam/pcorp/documents/en/pacificpower/rates-regulation/california/CA_Price_Summary.pdf
      // https://www.pacificpower.net/content/dam/pcorp/documents/en/pacificpower/rates-regulation/oregon/tariffs/Oregon_Price_Summary.pdf

      // https://www.pacificpower.net/about/value/residential-price-comparison.html
      powerSources: [
        {
          name: 'National Average',
          emissionsPerKwh: 4.33 * (10 ** -4), // metric tons CO2/kWh
          dollarsPerKwh: 0.172,
        },
        // {
        //   name: 'Coal Only',
        //   emissionsPerKwh: 0.000512,
        //   dollarsPerKwh: 0.172,
        // },
        {
          name: 'Renewable Only',
          emissionsPerKwh: 0,
          dollarsPerKwh: 0.192,
        },
        {
          name: 'WA',
          emissionsPerKwh: 4.33 * (10 ** -4), // metric tons CO2/kWh
          dollarsPerKwh: 0.102,
        },
        {
          name: 'OR',
          emissionsPerKwh: 0.000512,
          dollarsPerKwh: 0.117,
        },
        {
          name: 'CA',
          emissionsPerKwh: 4.33 * (10 ** -4), // metric tons CO2/kWh
          dollarsPerKwh: 0.163,
        },
      ],
      center: { lat: 40, lng: -90 },
      zoom: 6,
    };
  },
  mounted() {
  },
  methods: {
  },
  created() {
    this.$parent.getEVData();
    // this.$parent.getEVDataPaginated();
    this.$parent.getChargerData();
    this.$parent.getIncentiveData();
  },
};
</script>

<style scoped>
#app {
  --accent: #07828D; /* rgb(19, 147, 159); #599346; */
  --active-link-blue: #07828D;
  --client-color: #07828D; /* rgb(136, 189, 197); */
  --client-color-darker: var(--accent);
}
header {
  padding: 0 3%;
}
header img {
  margin-left: 0;
}
nav {
  justify-content: space-between;
}
.navbar {
  padding-right: 0 !important;
  margin-right: -10px;
}
.navbar a {
  font-size: clamp(15px, 1.6vw, 19px);
  margin: 0 0.8vw;
}

/* .ev-model-img-container {
  text-align: center;
  overflow: hidden;
  height:160px;
}
.ev-model-img-container img {
  max-width: 190%;
  height:auto;
  max-height: 250px;
  margin: -50px -100px -40px -100px;
} */

/* .navbar a:last-of-type {
  margin-right: 0;
} */
@media screen and (max-width: 1420px) {
  .navbar {
    padding: 15px 0;
  }
  nav a.router-link-active {
    text-underline-offset: 4px;
  }
  .navbar a {
    font-size: 16px;
  }
}
@media screen and (max-width: 1230px) {
  /* nav {
    padding-right: 25px;
  } */
  .navbar {
    max-width: 700px;
    justify-content: flex-end;
    margin-right: -15px;
  }
  .navbar a {
    margin: 0 13px;
  }
}
</style>

<!-- --accent: #599346;
--client-color-darker: #438441;
--client-color-selected: #1B6CB5;
--client-color-red: #D98C24;
--client-color-savings-icons: #599346; -->
